import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './index.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from 'theme/theme';
import { FC_SYSTEM_AUTH_ACCESS_TOKEN, FC_SYSTEM_AUTH_REFRESH_TOKEN } from 'requests/auth';
import { ReCaptchaProvider } from 'state/contexts/recaptcha';
import { LicenceProvider } from 'state/contexts/licence';
import { useIdleLogout } from 'hooks/useIdleLogout';
import App from './App';
import reportWebVitals from './reportWebVitals';

const LOGOUT_TIMEOUT = 900000; // 15 min in milliseconds

const originalSetItem = localStorage.setItem.bind(localStorage);
localStorage.setItem = function (...rest) {
  const event = new Event('itemInserted');
  document.dispatchEvent(event);
  originalSetItem(...rest);
};

const originalRemoveItem = localStorage.removeItem.bind(localStorage);
localStorage.removeItem = function (...rest) {
  const event = new Event('itemRemoved');
  document.dispatchEvent(event);
  originalRemoveItem(...rest);
};

const IdleLogout = () => {
  useIdleLogout({
    timeout: LOGOUT_TIMEOUT,
    onLogout: () => {
      localStorage.removeItem(FC_SYSTEM_AUTH_ACCESS_TOKEN);
      localStorage.removeItem(FC_SYSTEM_AUTH_REFRESH_TOKEN);
    },
  });
  return null;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LicenceProvider>
        <ReCaptchaProvider>
          <IdleLogout />
          <App />
        </ReCaptchaProvider>
      </LicenceProvider>
    </ThemeProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
